"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#4A453F"; // dark grey
const headerTextColor = "#D1CCBF"; // light grey
const headerBackgroundColor = "#1C1B19"; // black
const appAccentColor = "#D1CCBF";
const mainInfoPortrait = headerTextColor;
const mainInfoLandscape = brand;
const colorAppBar = "#1C1B19";
const colorOnAppBar = "#D1CCBF";
const colorPrimary = "#D1CCBF";
const colorPrimaryDarker = "#a79e85";
const colorPrimaryLighter = "#f6f5f2";
const colorOnPrimary = "#4A453F";
const colorSecondary = "#D1CCBF";
const colorOnSecondary = "#4A453F";
const colorTiles = ["#D1CCBF", "#D1CCBF", "#D1CCBF"];
const fontFamily = `
@font-face{
    font-family: 'Guardi';
    src: url('/fonts/guardi/lte52105-webfont.eot');
    src: url('/fonts/guardi/lte52105-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/guardi/lte52105-webfont.woff') format('woff'),
         url('/fonts/guardi/lte52105-webfont.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
}

@font-face{
    font-family: 'Guardi';
    src: url('/fonts/guardi/lte52107-webfont.eot');
    src: url('/fonts/guardi/lte52107-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/guardi/lte52107-webfont.woff') format('woff'),
         url('/fonts/guardi/lte52107-webfont.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
}

@font-face {
    font-family: 'Open Sans';
    src: url('/fonts/open-sans/opensans_regular/OpenSans-Regular-webfont.eot');
    src: url('/fonts/open-sans/opensans_regular/OpenSans-Regular-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/open-sans/opensans_regular/OpenSans-Regular-webfont.woff') format('woff'),
         url('/fonts/open-sans/opensans_regular/OpenSans-Regular-webfont.ttf') format('truetype'),
         url('/fonts/open-sans/opensans_regular/OpenSans-Regular-webfont.svg#open_sansregular') format('svg');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'Open Sans';
    src: url('/fonts/open-sans/opensans_bold/OpenSans-Bold-webfont.eot');
    src: url('/fonts/open-sans/opensans_bold/OpenSans-Bold-webfont.eot?#iefix') format('embedded-opentype'),
         url('/fonts/open-sans/opensans_bold/OpenSans-Bold-webfont.woff') format('woff'),
         url('/fonts/open-sans/opensans_bold/OpenSans-Bold-webfont.ttf') format('truetype'),
         url('/fonts/open-sans/opensans_bold/OpenSans-Bold-webfont.svg#open_sansbold') format('svg');
    font-weight: 700;
    font-style: normal;
}

html {
    font-family: "Guardi", "Open Sans", sans-serif;
}
`;
exports.default = {
    mainInfoLandscape,
    mainInfoPortrait,
    headerTextColor,
    appAccentColor,
    brand,
    headerBackgroundColor,
    fontFamily,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
